import Vue from 'vue'
import {
  Descriptions,
  Button,
  Form,
  FormItem,
  Input,
  Message,
  MessageBox,
  Header,
  Container,
  Aside,
  Main,
  Footer,
  Menu,
  Submenu,
  MenuItem,
  Breadcrumb,
  BreadcrumbItem,
  Card,
  Row,
  Col,
  Table,
  TableColumn,
  Switch,
  Tooltip,
  Pagination,
  Dialog,
  Tree,
  Tag,
  Select,
  Option,
  Loading,
  Cascader,
  Alert,
  Tabs,
  TabPane,
  Steps,
  Step,
  CheckboxGroup,
  Checkbox,
  Upload,
  Timeline,
  TimelineItem,
  DatePicker,
  TimePicker,
  RadioGroup,
  Radio,
  RadioButton,
  Popconfirm,
  Popover,
  Autocomplete,
  Progress,
  Avatar,
  Notification,
  TimeSelect,
    Empty,
    Image,
    Dropdown,
    DropdownMenu,
    DropdownItem,
  Drawer,
  Rate,
  Divider
} from 'element-ui'
// 导入elementui全局样式
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(Loading)
Vue.use(Button)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Header)
Vue.use(Container)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Footer)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Card)
Vue.use(Row)
Vue.use(Col)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Switch)
Vue.use(Tooltip)
Vue.use(Pagination)
Vue.use(Dialog)
Vue.use(Tree)
Vue.use(Tag)
Vue.use(Select)
Vue.use(Option)
Vue.use(Cascader)
Vue.use(Alert)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Steps)
Vue.use(Step)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.use(Upload)
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.use(DatePicker)
Vue.use(TimePicker)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(RadioButton)
Vue.use(Popconfirm)
Vue.use(Popover)
Vue.use(Autocomplete)
Vue.use(Progress)
Vue.use(Avatar)
Vue.use(TimeSelect)
Vue.use(Empty)
Vue.use(Image)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Drawer)
Vue.use(Rate)
Vue.use(Divider)

// Vue.prototype.$message = Message
Vue.prototype.$message = function ({ message, type, time }) {
  return Message({
    showClose: true,
    message: message,
    type: type,
    duration: time || 5000
  });
}
Vue.prototype.$msgbox = MessageBox

Vue.prototype.$alert = MessageBox.alert

Vue.prototype.$confirm = MessageBox.confirm

Vue.prototype.$showLoading = function (params = {}) {
  const loading = Loading.service({           // 声明一个loading对象
    lock: params.lock || true,                             // 是否锁屏
    text: params.text || '正在加载...',                     // 加载动画的文字
    spinner: params.spinner || 'el-icon-loading',             // 引入的loading图标
    background: params.background || 'rgba(0, 0, 0, 0.3)',       // 背景颜色
    target: params.target || 'document.body',                    // 需要遮罩的区域
    body: params.body || false,
    customClass: params.customClass || 'loading-mask',
    fullscreen: params.fullscreen || true,                     // 遮罩层新增类名
  })
  const delay = params.delay || 15000;
  setTimeout(function () {                  // 设定定时器，超时5S后自动关闭遮罩层，避免请求失败时，遮罩层一直存在的问题
    loading.close();                        // 关闭遮罩层
  }, delay)
  return loading;
}

Vue.prototype.$hideLoading = function () {
  Vue.prototype.$showLoading().close();
}

Vue.prototype.$notify = function ({ message, type, time, title ,position}) {
  const html = `<div style="word-break:break-all;}">${message}</div>`
  return Notification({
    type: type,
    duration: time || 30000,
    dangerouslyUseHTMLString: true,
    message: html,
    title: title,
    position: position || 'top-right'
  });
}
